import React from 'react'
import { Title } from 'components/search/result-card'

export default function ProgramName({ hit }) {
  return <Title>{hit.program_name}</Title>
}
